export default {
  estaCarregando: false,
  objCidade: {},
  lista: [],
  estadoSelecionadoId: null
}
